import { render, staticRenderFns } from "./Visit-Team-Detail.vue?vue&type=template&id=03cd85a0&scoped=true"
import script from "./Visit-Team-Detail.vue?vue&type=script&lang=js"
export * from "./Visit-Team-Detail.vue?vue&type=script&lang=js"
import style0 from "./Visit-Team-Detail.vue?vue&type=style&index=0&id=03cd85a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cd85a0",
  null
  
)

export default component.exports